var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchPredictionRounded48Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "batch-prediction-rounded-48dp",
    transform: "translate(0 -0.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17356",
    "data-name": "Ret\\xE2ngulo 17356",
    width: 16,
    height: 16,
    transform: "translate(0 0.193)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7293",
    "data-name": "Caminho 7293",
    d: "M16.767,7.421H9.739A1.389,1.389,0,0,0,8.333,8.784V15.6a1.389,1.389,0,0,0,1.406,1.363h7.028A1.389,1.389,0,0,0,18.172,15.6V8.784A1.389,1.389,0,0,0,16.767,7.421Zm-3.514,8.517h0a.694.694,0,0,1-.7-.681v-.341h1.406v.341A.694.694,0,0,1,13.253,15.939Zm.7-1.7H12.55c0-1.022-1.757-2.044-1.757-3.407a2.461,2.461,0,0,1,4.92,0C15.713,12.191,13.956,13.213,13.956,14.235ZM17.47,6.4H9.036A1.037,1.037,0,0,1,10.09,5.377h6.325A1.037,1.037,0,0,1,17.47,6.4Zm-.7-2.044H9.739a1.037,1.037,0,0,1,1.054-1.022h4.92a1.037,1.037,0,0,1,1.054,1.022Z",
    transform: "translate(-5.177 -2.03)",
    fill: "#6d6d6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchPredictionRounded48Dp);
export default __webpack_public_path__ + "static/media/batch-prediction-rounded-48dp.8ebe7f951edbbca64155f7397c8b76df.svg";
export { ForwardRef as ReactComponent };